<template>
  <v-container>
    <h1>{{ get("header-1") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <p>
              {{ get("company") }} 
              {{ get("p-1.1") }}
            </p>
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-img :src="houseImage" class="image"></v-img>
          </v-col>
        </v-row>
        <div :class="theme + '-alt-background-1'">
          <div>
            <h2>{{ get("header-2") }}</h2>
            <p>
              {{ get("p-2.1") }}
              
            </p>
            <br />
            <ul>
              <li>
                <p>
                  {{ get("p-2.2") }}
                </p>
              </li>
              <li>
                <p>
                  {{ get("p-2.3") }}
                </p>
              </li>
              <li>
                <p>
                  {{ get("p-2.4") }}
                </p>
              </li>
              <li>
                <p>
                  {{ get("p-2.5") }}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <h2>{{ get("header-3") }}</h2>
        <p>
          {{ get("p-3.1") }}
          <phonenumber phone="(719) 390-7663"></phonenumber>
          {{ get("p-3.2") }}
          <a href="/contact">{{ get("contact")}}</a>
          {{ get("p-3.3") }}
        </p>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "@/components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import store from "@/store";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "roof-repair",

  components: {
    estimate,
    phonenumber
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

    created() {
    this.pageName = "roof-repair";
  },

  data: () => ({
    houseImage: require("@/assets/houses-2.jpeg"),
    textStyle: {
      color: "orange",
    },
  }),

  mixins: [localizationMixin],
  methods: {
    getLocalization() {    
    }
  },

  watch: {
    "$store.state.dark": function() {
      this.textStyle.color = store.state.dark ? "orange" : '#8B008B';
    }
  },
};
</script>

<style lang="scss" scoped>

</style>